// ./src/services/apiService.js

// Die Webhook-Adresse kommt aus der Umgebung.
//
// Vorher stand hier fest im Code:
//   this.baseURL = "https://n8n.hilke.vj0.de";   // "fest codiert fuer jetzt"
// Die .env enthielt zwar VITE_N8N_WEBHOOK_URL, aber niemand las sie.
//
// Vite backt VITE_-Variablen zur BAUZEIT ins Bundle - eine Aenderung
// erfordert also einen neuen Build, kein blosses Neustarten.
const WEBHOOK_URL =
  import.meta.env.VITE_N8N_WEBHOOK_URL ||
  "https://n8n.hilke.vj0.de/webhook/upload-meeting";

class ApiService {
  constructor() {
    this.webhookUrl = WEBHOOK_URL;
  }

  // Datei zur Transkription an den n8n-Workflow schicken.
  async uploadForTranscription(file, onProgress = null) {
    try {
      const formData = new FormData();
      // Der Feldname "data" muss zu binaryPropertyName im Webhook-Knoten
      // passen - dort steht ebenfalls "data".
      formData.append("data", file);

      const response = await fetch(this.webhookUrl, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        // Aussagekraeftiger als der blosse Statuscode: Bei 413 ist die
        // Datei zu gross fuer n8n, bei 404 laeuft der Workflow nicht.
        let hinweis = `Der Transkriptions-Dienst antwortete mit ${response.status}.`;
        if (response.status === 413) {
          hinweis = "Die Datei ist zu groß für den Transkriptions-Dienst.";
        } else if (response.status === 404) {
          hinweis = "Der Transkriptions-Dienst ist nicht erreichbar.";
        }
        throw new Error(hinweis);
      }

      const result = await response.json();

      // n8n gibt das Ergebnis der Groq-Transkription durch. Je nach
      // Einstellung des Antwort-Knotens liegt der Text in "text" oder in
      // einem eigenen Feld.
      return {
        transcript: result.text || result.myField || "",
        success: true,
      };
    } catch (error) {
      console.error("Transcription upload failed:", error);
      throw {
        success: false,
        error: error.message || "Upload fehlgeschlagen",
      };
    }
  }

  // Erreichbarkeitspruefung.
  //
  // Vorher wurde hier `${this.baseURL}/upload-meeting` abgefragt - ohne
  // das /webhook/ davor, das der Upload sehr wohl verwendet. Die Pruefung
  // konnte also nie erfolgreich sein.
  async healthCheck() {
    try {
      const response = await fetch(this.webhookUrl, { method: "OPTIONS" });
      return response.ok;
    } catch (error) {
      console.error("Health check failed:", error);
      return false;
    }
  }

  getWebhookUrl() {
    return this.webhookUrl;
  }
}

export default new ApiService();
